
<template>
  <vs-row>
    <div class="mt-5 w-full">
      <vs-row class="tabCard">
        <vs-row>
          <h3 class="p-5">{{ pagename }}</h3>
        </vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
          <div class="dropdown w-full" id="dropdown">
            <div class="addCardFont font-semibold ml-5">
              Select Issuer<span
                v-if="errors.issuerName.success"
                class="sterik"
              >
                *</span
              >
              <span v-if="!errors.issuerName.success"> *</span>
            </div>
            <vs-input
              placeholder="Select Issuer"
              :danger="errors.issuerName.success"
              :danger-text="errors.issuerName.msg"
              class="w-full p-4 pt-4 pb-1"
              @click="handleFilter"
              v-on-clickaway="closeColorList"
              v-model="cardDetails.selectedIssuer.name"
              readonly
            />
            <div class="dropdown-content" v-show="toggleColorList">
              <div
                class="colorItemContainer"
                @click="cardDetails.selectedIssuer = issuer"
                :key="index"
                v-for="(issuer, index) in issuersList"
              >
                <div
                  class="colorIconStyle"
                  :style="{ 'background-color': issuer.color }"
                ></div>
                <span class="colorTextStyle">{{ issuer.name }}</span>
              </div>
            </div>
          </div>
          <div class="addCardFont font-semibold ml-5 pt-5">
            Select Credit Card
            <span v-if="errors.cardName.success" class="sterik"> *</span>
            <span v-if="!errors.cardName.success"> *</span>
          </div>
          <vs-row>
            <vs-col class="px-4 mt-4 pr-4">
              <select
                v-if="cardsList.length > 0"
                v-model="cardDetails.card._id"
                :class="{
                  'w-full posSelect  p-3': true,
                  'mb-2': cardDetails.card.name,
                }"
                @change="handleCardFilter"
              >
                <option
                  v-for="card in cardsList"
                  :key="card._id"
                  :value="card._id"
                >
                  {{ card.name }}
                </option>
              </select>
              <select
                v-if="
                  cardsList.length <= 0 &&
                  cardDetails.card.name == '' &&
                  isCardListLoaded == false
                "
                id="selec"
                class="w-full clas p-3"
                :disabled="true"
              >
                <option
                  v-if="
                    cardDetails.card.name == '' && isCardListLoaded == false
                  "
                  selected
                >
                  Select Card
                </option>
              </select>
              <select
                v-if="
                  cardsList.length <= 0 &&
                  cardDetails.card.name == '' &&
                  isCardListLoaded == true
                "
                id="selec"
                class="w-full clas p-3"
                :disabled="true"
              >
                <option
                  v-if="cardDetails.card.name == '' && isCardListLoaded == true"
                  selected
                >
                  No Cards Available
                </option>
              </select>
              <select
                v-if="cardsList.length <= 0 && cardDetails.card.name != ''"
                class="w-full posSelect p-3"
                :disabled="true"
              >
                <option selected>
                  {{ cardDetails.card.name }}
                </option>
              </select>
              <span class="select_error_msg" v-if="errors.cardName.success">
                {{ errors.cardName.msg }}</span
              >
            </vs-col>
          </vs-row>
          <div
            v-if="pagename == 'Offer Details'"
            class="addCardFont font-semibold ml-5 mt-4"
          >
            Bonus Amount<span v-if="errors.bonus.success" class="sterik">
              *</span
            >
            <span v-if="!errors.bonus.success"> *</span>
          </div>

          <div v-else class="addCardFont font-semibold ml-5 mt-6">
            Bonus Amount<span v-if="errors.bonus.success" class="sterik">
              *</span
            >
            <span v-if="!errors.bonus.success"> *</span>
          </div>
          <vs-input
            class="w-full p-4 pb-1"
            placeholder="Enter Bonus Amount"
            v-model="cardDetails.bonus"
            :danger="errors.bonus.success"
            :danger-text="errors.bonus.msg"
            @input="validateBonus($event), checkinput()"
            maxLength="120"
          />
          <div class="addCardFont font-semibold mt-5 ml-5">
            Bonus Type
            <span v-if="errors.bonusType.success" class="sterik"> *</span>
            <span v-if="!errors.bonusType.success"> *</span>
          </div>
          <vs-row>
            <vs-col class="px-4 mt-4 pr-4">
              <select
                v-if="
                  cardDetails.bonusType.value &&
                  cardDetails.bonusType.value == 'select_bonus_type'
                "
                id="selec"
                v-model="cardDetails.bonusType.value"
                class="w-full clas p-3"
                v-on:change="onKeyDateChanged()"
              >
                <option
                  v-for="tp in bonus_type_option"
                  :key="tp.value"
                  :value="tp.value"
                >
                  {{ tp.name }}
                </option>
              </select>
              <select
                v-else
                v-model="cardDetails.bonusType.value"
                class="w-full posSelect p-3"
                v-on:change="onKeyDateChanged()"
              >
                <option
                  v-for="tp in bonus_type_option"
                  :key="tp.value"
                  :value="tp.value"
                >
                  {{ tp.name }}
                </option>
              </select>
              <span class="select_error_msg" v-if="errors.bonusType.success">
                {{ errors.bonusType.msg }}</span
              >
            </vs-col>
          </vs-row>

          <div class="addCardFont font-semibold ml-5 mt-6">
            Link Url<span v-if="errors.url.success" class="sterik"> *</span>
            <span v-if="!errors.url.success"> *</span>
          </div>
          <vs-input
            class="w-full p-4 pb-1"
            v-model="cardDetails.linkUrl"
            :danger="errors.url.success"
            :danger-text="errors.url.msg"
            @input="validateLinkUrl($event), checkinputlink()"
            maxLength="120"
          />
          <div class="mt-4 mb-4">
            <vs-col
              vs-lg="6"
              vs-sm="6"
              class="inputContainer max-height-5-24 pr-5"
              vs-type="flex"
              vs-justify="flex-start"
            >
              <vs-checkbox
                v-model="cardDetails.redirect"
                vs-name="redirect"
                :vs-value="true"
                class="mb-5 ml-5"
              />
              <div class="addCardFont font-semibold ml-0 mb-5">
                Add Redirect
              </div>
            </vs-col>
          </div>

          <div class="addCardFont font-semibold">
            <vs-col>
              <vs-row>
                <div class="addCardFont font-semibold ml-5 mt-0 mb-3">
                  Additional Disclosures
                  <span v-if="errors.disclosure.success" class="sterik">
                    *</span
                  >
                </div>
              </vs-row>
              <vs-row class="mt-3">
                <vs-radio
                  v-model="cardDetails.disclosure"
                  vs-name="disclosure"
                  vs-value="non-affiliate"
                  class="ml-5 mr-5 addCardFont textSize"
                  @change="disclosureselect()"
                >
                  Non-Affiliate
                </vs-radio>
                <vs-radio
                  v-model="cardDetails.disclosure"
                  vs-name="disclosure"
                  vs-value="amex"
                  class="mr-5 ml-5 addCardFont textSize"
                  @change="disclosureselect()"
                >
                  Amex
                </vs-radio>
                <vs-radio
                  v-model="cardDetails.disclosure"
                  vs-name="disclosure"
                  vs-value="none"
                  class="mr-5 ml-5 addCardFont textSize"
                  @change="disclosureselect()"
                >
                  None
                </vs-radio>
              </vs-row>
              <vs-row v-if="cardDetails.disclosure == 'amex'" class="mt-3">
                <div class="addCardFont font-semibold ml-5 mt-2">
                  Rates and Fees<span
                    v-if="errors.rates_fees.success"
                    class="sterik"
                  >
                    *</span
                  >
                  <span v-if="!errors.rates_fees.success"> *</span>
                </div>
                <vs-input
                  class="w-full p-4 pb-1"
                  v-model="cardDetails.rates_fees"
                  :danger="errors.rates_fees.success"
                  :danger-text="errors.rates_fees.msg"
                  @input="checkinputratesfees()"
                  maxLength="120"
                />
              </vs-row>
              <span
                class="select_error_msg ml-4 pb-5 mt-2"
                v-if="errors.disclosure.success"
              >
                {{ errors.disclosure.msg }}</span
              >
            </vs-col>
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
          <vs-row>
            <vs-col class="">
              <div class="addCardFont font-semibold ml-5 mb-4">
                <vs-row>
                  <vs-col
                    vs-lg="8"
                    vs-sm="8"
                    class="inputContainer max-height-5-24"
                    vs-type="flex"
                    vs-justify="flex-start"
                  >
                    Expiration Date<span
                      v-if="errors.date.success"
                      class="sterik"
                      >*</span
                    >
                    <span v-if="!errors.date.success"> *</span>
                  </vs-col>
                  <vs-col
                    vs-lg="4"
                    vs-sm="4"
                    class="inputContainer max-height-5-24"
                    vs-type="flex"
                    vs-justify="flex-end"
                  >
                    <vs-checkbox
                      v-model="dateNotAvailable"
                      vs-name="dateNotAvailable"
                      :vs-value="true"
                      class="mb-4"
                      @click="dateNotAvailableSelected()"
                    />
                    <div class="addCardFont font-semibold ml-0 mb-0">N/A</div>
                  </vs-col>
                </vs-row>

                <Datepicker
                  :disabled="dateNotAvailable"
                  id="datepicker"
                  v-model="cardDetails.date"
                  @opened="datepickerOpened()"
                  @closed="datepickerClosed()"
                  wrapper-class="p-0 mt-0 pt-0"
                  calendar-class="posCalendar"
                  placeholder="MM/DD/YYYY"
                  format="MM/dd/yyyy"
                />

                <span class="select_error_msg" v-if="errors.date.success">
                  {{ errors.date.msg }}</span
                >
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="mt-2 pl-5">
              <div class="addCardFont font-semibold mb-4">
                Bonus Description
              </div>
              <vs-textarea
                id="textare"
                style="background-color: #rgb(52, 52, 52) !important"
                placeholder="e.g. spend $3000 in the first three months"
                v-model="cardDetails.bonusDescription"
                :danger="errors.bonusDescription.success"
                :danger-text="errors.bonusDescription.msg"
              />
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="mt-0 pl-5">
              <div class="addCardFont font-semibold mb-4">Offer Details</div>
              <vs-textarea
                id="textare"
                style="
                  color: white !important;
                  background-color: #rgb(52, 52, 52) !important;
                "
                placeholder="e.g. this offer is the best offer you can get"
                v-model="cardDetails.offerDetails"
                :danger="errors.offerDetails.success"
                :danger-text="errors.offerDetails.msg"
              />
            </vs-col>
          </vs-row>
          <div class="mt-0 mb-4">
            <vs-col
              vs-lg="6"
              vs-sm="6"
              class="inputContainer max-height-5-24 pr-5"
              vs-type="flex"
              vs-justify="flex-start"
            >
              <vs-checkbox
                v-model="cardDetails.hide_from_dashboard"
                vs-name="hide_from_dashboard"
                :vs-value="true"
                class="mb-5 ml-5"
              />
              <div class="addCardFont font-semibold ml-0 mb-5">
                Hide from Dashboard
              </div>
            </vs-col>
            <vs-col
              vs-lg="6"
              vs-sm="6"
              class="inputContainer max-height-5-24 pr-5"
              vs-type="flex"
              vs-justify="flex-end"
              v-if="this.pagename == 'Add Offer'"
            >
              <vs-checkbox
                v-model="pushNotification"
                vs-name="pushNotification"
                :vs-value="true"
                class="mb-5 ml-5"
              />
              <div class="addCardFont font-semibold ml-0 mb-5">
                Send Push Notification
              </div>
            </vs-col>
          </div>
          <div class="addCardFont font-semibold">
            <vs-col>
              <vs-row>
                <div class="addCardFont font-semibold ml-5 mt-1">
                  Card Type
                  <span v-if="errors.emoji.success" class="sterik"> *</span>
                </div>
              </vs-row>
              <vs-row class="">
                <vs-radio
                  v-model="cardDetails.emoji"
                  vs-name="emoji"
                  vs-value="unicorn.png"
                  class="ml-5 mr-5 addCardFont textSize"
                  @change="
                    (cardDetails.card_type = 'unicorn.png'), emojiselect()
                  "
                >
                  <vue-load-image>
                    <img
                      class="ml-1"
                      slot="image"
                      :src="require('@/assets/images/emoji/unicorn.png')"
                      height="21.36"
                      width="22.65"
                    />
                  </vue-load-image>
                </vs-radio>
                <vs-radio
                  v-model="cardDetails.emoji"
                  vs-name="emoji"
                  vs-value="diamond.png"
                  class="mr-5 ml-5 addCardFont textSize"
                  @change="(cardDetails.emoji = 'diamond.png'), emojiselect()"
                >
                  <vue-load-image>
                    <img
                      class="ml-1"
                      slot="image"
                      :src="require('@/assets/images/emoji/diamond.png')"
                      height="20.47"
                      width="22.89"
                    />
                  </vue-load-image>
                </vs-radio>
                <vs-radio
                  v-model="cardDetails.emoji"
                  vs-name="emoji"
                  vs-value="fire.png"
                  class="m-5 ml-15 addCardFont textSize"
                  @change="(cardDetails.card_type = 'fire.png'), emojiselect()"
                >
                  <vue-load-image>
                    <img
                      class="ml-1"
                      slot="image"
                      :src="require('@/assets/images/emoji/fire.png')"
                      height="24.43"
                      width="18.91"
                    />
                  </vue-load-image>
                </vs-radio>
              </vs-row>
              <span
                class="select_error_msg ml-5 pb-5"
                v-if="errors.emoji.success"
              >
                {{ errors.emoji.msg }}</span
              >
            </vs-col>
          </div>
        </vs-col>
      </vs-row>
    </div>
    <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-button class="ml-3 mr-3 mt-2 px-6 wizardBtnPad" @click="verifyPush()"
        >Save</vs-button
      >
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="Verify.success"
      @close="closefunc()"
    >
      <h5>{{ Verify.msg }}</h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="askPush.success">
      <div style="magine-bottom: 30px" class="mb-5">
        <h5>{{ askPush.msg }}</h5>
      </div>

      <div
        style="text-align: center; margin-top: 30px"
        vs-type="flex"
        vs-justify="center"
      >
        <vs-button
          class="mt-11 mr-5"
          @click="allowPush()"
          color="primary"
          type="filled"
          >Yes</vs-button
        >
        <vs-button
          class="mt-11 ml-5"
          @click="disallowPush()"
          color="primary"
          type="filled"
          >No</vs-button
        >
      </div>
    </vs-popup>
  </vs-row>
</template>

<script>
import {
  UploadCloudIcon,
  PlusSquareIcon,
  MinusSquareIcon,
} from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import Datepicker from "vuejs-datepicker";

import EventBus from "@/event-bus.js";
import Editor from "@tinymce/tinymce-vue";
import VueLoadImage from "vue-load-image";

import {
  validateBonus,
  validateUploadPhoto,
  validateAlphaNumeric,
  validateNumeric,
  validateIssuerName,
  validateLinkUrl,
  validateCardName,
  validateBonusType,
  validateUrl,
  validateExpirationDate,
  validateEmoji,
  validateDisclosure,
  validateRatesFees,
} from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  data() {
    return {
      currentUserId: "",
      valuation: "",
      toggleColorList: false,
      pagename: "",
      currentSelectedIssuer: "",
      isCardListLoaded: false,

      cardDetails: {
        selectedIssuer: {
          name: "",
        },
        emoji: "",
        bonus: "",
        hide_from_dashboard: false,
        card: {
          name: "",
          _id: "",
          photo: "",
          issuer: "",
        },
        offerDetails: "",
        date: "",
        bonusType: {
          value: "select_bonus_type",
        },
        // bonusType:"",
        bonusDescription: "",
        linkUrl: "",
        redirect: false,
        disclosure: "",
        rates_fees: "",
      },
      dateNotAvailable: false,
      pushNotification: false,
      Verify: {
        success: false,
        msg: "",
      },
      askPush: {
        success: false,
        msg: "",
      },
      //Select Bonus Type
      bonus_type_option: [
        {
          name: "Select Bonus Type",
          value: "select_bonus_type",
        },
        {
          name: "Bonus Miles",
          value: "bonus_miles",
        },
        {
          name: "Bonus Points",
          value: "bonus_points",
        },
        {
          name: "Cash Back",
          value: "cash_back",
        },
      ],
      issuersList: [],
      bonusList: [],
      cardsList: [],
      toggleCardsList: false,
      linkUrlList: [],

      errors: {
        issuerName: {
          msg: "",
          success: false,
        },
        emoji: {
          msg: "",
          success: false,
        },
        bonus: {
          msg: "",
          success: false,
        },
        cardName: {
          msg: "",
          success: false,
        },
        date: {
          msg: "",
          success: false,
        },
        bonusDescription: {
          msg: "",
          success: false,
        },
        url: {
          msg: "",
          success: false,
        },
        offerDetails: {
          msg: "",
          success: false,
        },
        bonusType: {
          msg: "",
          success: false,
        },
        disclosure: {
          msg: "",
          success: false,
        },
        rates_fees: {
          msg: "",
          success: false,
        },
        set_issuer_once: 3,
        set_card_once: 3,
      },

      validateBonus,
      validateUploadPhoto,
      validateAlphaNumeric,
      validateNumeric,
      validateLinkUrl,
      validateIssuerName,
      validateCardName,
      validateBonusType,
      validateExpirationDate,
      validateEmoji,
      validateDisclosure,
      validateRatesFees,
      genericErrorMessage,
      validateUrl,
      toast,
    };
  },
  methods: {
    closefunc() {
      if (this.Verify.success == true) {
        this.Verify.success = false;
      } else {
      }
    },
    disallowPush() {
      this.pushNotification = false;
      this.askPush.success = false;
      this.askPush.msg = "";
      this.save();
    },
    allowPush() {
      this.askPush.success = false;
      this.askPush.msg = "";
      this.save();
    },
    async verifyPush() {
      await this.validateIssuerName(this.cardDetails.selectedIssuer.name);
      await this.validateCardName(
        this.cardDetails.card._id ? this.cardDetails.card._id.toString() : ""
      );
      await this.validateBonus(this.cardDetails.bonus.toString());
      await this.validateBonusType(this.cardDetails.bonusType.value);
      await this.validateLinkUrl(this.cardDetails.linkUrl);
      if (!this.dateNotAvailable) {
        await this.validateExpirationDate(this.cardDetails.date.toString());
      }
      await this.validateEmoji(this.cardDetails.emoji);
      await this.validateDisclosure(this.cardDetails.disclosure);
      await this.validateRatesFees(
        this.cardDetails.disclosure,
        this.cardDetails.rates_fees
      );
      let {
        issuerName,
        cardName,
        bonus,
        bonusType,
        url,
        date,
        emoji,
        disclosure,
        rates_fees,
      } = this.errors;
      if (
        issuerName.success ||
        cardName.success ||
        bonus.success ||
        bonusType.success ||
        url.success ||
        date.success ||
        emoji.success ||
        disclosure.success ||
        rates_fees.success
      ) {
        return false;
      } else {
        if (this.pushNotification == true) {
          this.askPush.success = true;
          this.askPush.msg =
            "Are you sure you want to send push notification for this offer?";
        } else {
          this.save();
        }
      }
    },
    getIssuers() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors)
          .then(async (res) => {
            if (res.data.success) {
              resolve(
                (this.issuersList = res.data.data.issuers),
                (this.filtererdList = res.data.data.filteredIssuers)
              );
              // if(this.$route.params.data && this.set_issuer_once==1){
              //     console.log("helloo issuer")
              // this.cardDetails.selectedIssuer=this.issuersList.find(a=>a._id==this.$route.params.data.card.issuer)
              // this.set_issuer_once=0;
              // this.getCardsList()
              // }
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getCardsList() {
      this.isCardListLoaded = false;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(async (resolve) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetIssuerCards
            + "/" + this.cardDetails.selectedIssuer._id + "/cards"
            )
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve((this.cardsList = res.data.data));
                this.isCardListLoaded = true;
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },
    checkinput() {
      //for input field of bonus amount

      if (
        !(this.cardDetails.bonus[this.cardDetails.bonus.length - 1] >= 48) &&
        !(this.cardDetails.bonus[this.cardDetails.bonus.length - 1] <= 57)
      ) {
        this.cardDetails.bonus = this.cardDetails.bonus.slice(0, -1);
      }
    },

    async checkinputlink() {
      if(this.cardDetails.linkUrl!=''){
        if(this.validateUrl(this.cardDetails.linkUrl)){
          this.errors.url = {
            msg: "",
            success: false,
          };
        }
        else{
          this.errors.url = {
            msg: "Valid Url is Required",
            success: true,
          }
        }
      }
    },
    async checkinputratesfees() {
      await this.validateRatesFees(
        this.cardDetails.disclosure,
        this.cardDetails.rates_fees
      );
    },

    onKeyDateChanged() {
      if (this.cardDetails.bonusType.value != "select_bonus_type") {
        this.errors.bonusType = {
          msg: "",
          success: false,
        };
      } else {
        this.errors.bonusType = {
          msg: "Bonus Type is Required",
          success: true,
        };
      }
      //for bonus type change
    },
    handleCardFilter() {
      this.toggleCardsList = true;
      if (this.cardDetails.card.name || this.cardDetails.card._id) {
        this.errors.cardName = {
          msg: "",
          success: false,
        };
      }
    },
    dateNotAvailableSelected() {
      this.cardDetails.date = "";

      this.errors.date = {
        msg: "",
        success: false,
      };
    },
    datepickerOpened() {
      this.errors.date = {
        msg: "",
        success: false,
      };
    },

    async datepickerClosed() {
      await this.validateExpirationDate(this.cardDetails.date.toString());
    },
    closeCardsList() {
      this.toggleCardsList = false;
    },
    emojiselect() {
      if (this.cardDetails.emoji) {
        this.errors.emoji = {
          msg: "",
          success: false,
        };
      }
    },
    disclosureselect() {
      if (this.cardDetails.disclosure) {
        this.errors.disclosure = {
          msg: "",
          success: false,
        };
      }
    },

    // handleFilter() {
    //   this.toggleColorList = true;
    // },
    async handleFilter() {
      this.toggleColorList = true;
    },
    closeColorList() {
      if (this.toggleColorList) {
        this.toggleColorList = false;
        if (this.cardDetails.selectedIssuer.name) {
          this.errors.issuerName = {
            msg: "",
            success: false,
          };
        }
        if (
          this.cardDetails.selectedIssuer.name != this.currentSelectedIssuer
        ) {
          this.currentSelectedIssuer = this.cardDetails.selectedIssuer.name;
          this.cardDetails.card._id = "";
          this.cardDetails.card.name = "";
          this.getCardsList();
        }
      }
    },

    async addFunc() {
      //console.log(this.cardDetails.card._id)
      await this.validateIssuerName(this.cardDetails.selectedIssuer.name);
      await this.validateCardName(
        this.cardDetails.card._id ? this.cardDetails.card._id.toString() : ""
      );
      await this.validateBonus(this.cardDetails.bonus.toString());
      await this.validateBonusType(this.cardDetails.bonusType.value);
      await this.validateLinkUrl(this.cardDetails.linkUrl);
      if (!this.dateNotAvailable) {
        await this.validateExpirationDate(this.cardDetails.date.toString());
      }
      await this.validateEmoji(this.cardDetails.emoji);
      await this.validateDisclosure(this.cardDetails.disclosure);
      await this.validateRatesFees(
        this.cardDetails.disclosure,
        this.cardDetails.rates_fees
      );
      await this.checkinputlink()
      let {
        issuerName,
        cardName,
        bonus,
        bonusType,
        url,
        date,
        emoji,
        disclosure,
        rates_fees,
      } = this.errors;
      if (
        issuerName.success ||
        cardName.success ||
        bonus.success ||
        bonusType.success ||
        url.success ||
        date.success ||
        emoji.success ||
        rates_fees.success ||
        disclosure.success
      ) {
        return false;
      } else {
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        if (!this.dateNotAvailable) {
          return new Promise(() => {
            this.$axios
              .post(
                this.$ApiKeys.BASE_URL + this.$EndPoints.Offers,
                {
                  card: this.cardDetails.card._id,
                  bonus_amount: this.cardDetails.bonus,
                  bonus_description: this.cardDetails.bonusDescription
                    ? this.cardDetails.bonusDescription
                    : "",
                  offer_details: this.cardDetails.offerDetails
                    ? this.cardDetails.offerDetails
                    : "",
                  bonus_type: this.cardDetails.bonusType.value,
                  expiration_date: this.cardDetails.date,
                  emoji: this.cardDetails.emoji.split(".")[0],
                  link: this.cardDetails.linkUrl,
                  redirect: this.cardDetails.redirect.toString(),
                  hide_from_dashboard: this.cardDetails.hide_from_dashboard,
                  push_notification: this.pushNotification
                    ? this.pushNotification
                    : false,
                  disclosure: this.cardDetails.disclosure
                    ? this.cardDetails.disclosure
                    : null,
                  rates_fees:
                    this.cardDetails.rates_fees &&
                    this.cardDetails.disclosure == "amex"
                      ? this.cardDetails.rates_fees
                      : null,
                }
              )
              .then(async (res) => {
                const errors  = res.data.response && res.data.response.errors?res.data.response.errors: null
                this.$vs.loading.close();
                if (res.data.success) {
                  this.$router.push({ name: "offers", params: { edit: true } });
                } else if (
                  errors &&
                  typeof errors === 'object' &&
                  Object.keys(errors)[0] 
                ) {
                  this.toast(errors[Object.keys(errors)[0]]);
                } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                // this.toast(this.genericErrorMessage());
                  if (e.response.status !== 401) {
                   this.toast(this.genericErrorMessage());
                  }
                // if (e.response.data.errors && e.response.data.errors.cardId) {
                //   //console.log("error", e);
                //   // this.$refs.wiz.changeTab(3,0);
                //   // this.errors.cardName = {
                //   //     msg: e.response.data.errors.card,
                //   //     success: true
                //   // };
                // } else {
                //   this.errors.cardName = {
                //     msg: "",
                //     sucess: false,
                //   };
                // }
              });
          });
        } else {
          return new Promise(() => {
            this.$axios
              .post(
                this.$ApiKeys.BASE_URL + this.$EndPoints.Offers,
                {
                  card: this.cardDetails.card._id,
                  bonus_amount: this.cardDetails.bonus,
                  bonus_description: this.cardDetails.bonusDescription
                    ? this.cardDetails.bonusDescription
                    : "",
                  offer_details: this.cardDetails.offerDetails
                    ? this.cardDetails.offerDetails
                    : "",
                  bonus_type: this.cardDetails.bonusType.value,

                  emoji: this.cardDetails.emoji.split(".")[0],
                  link: this.cardDetails.linkUrl,
                  redirect: this.cardDetails.redirect.toString(),
                  hide_from_dashboard: this.cardDetails.hide_from_dashboard,
                  push_notification: this.pushNotification
                    ? this.pushNotification
                    : false,
                  disclosure: this.cardDetails.disclosure
                    ? this.cardDetails.disclosure
                    : null,
                  rates_fees:
                    this.cardDetails.rates_fees &&
                    this.cardDetails.disclosure == "amex"
                      ? this.cardDetails.rates_fees
                      : null,
                }
              )
              .then(async (res) => {
                 const errors  = res.data.response && res.data.response.errors?res.data.response.errors: null;
                this.$vs.loading.close();
                if (res.data.success) {
                  this.$router.push({ name: "offers", params: { edit: true } });
                } else if (
                    errors &&
                    typeof errors === 'object' &&
                    Object.keys(errors)[0]
                  ) {
                    this.toast(errors[Object.keys(errors)[0]]);
                } else {
                    this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                // this.toast(this.genericErrorMessage());
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
                // if (e.response.data.errors && e.response.data.errors.cardId) {
                //   //console.log("error", e);
                //   // this.$refs.wiz.changeTab(3,0);
                //   // this.errors.cardName = {
                //   //     msg: e.response.data.errors.card,
                //   //     success: true
                //   // };
                // } else {
                //   this.errors.cardName = {
                //     msg: "",
                //     sucess: false,
                //   };
                // }
              });
          });
        }
      }
    },
    async save() {
      if (!this.$route.params || !this.$route.params.data) {
        //console.log(this.cardDetails);
        this.addFunc();
        return;
      }

      if (this.cardDetails.card._id) {
        this.cardDetails.card.name = this.cardsList.find(
          (a) => a._id == this.cardDetails.card._id
        ).name;
        this.cardDetails.card.issuer = {
          _id: this.issuersList.find(
            (a) => a.name == this.cardDetails.selectedIssuer.name
          )._id,
          name: this.issuersList.find(
            (a) => a.name == this.cardDetails.selectedIssuer.name
          ).name,
        };
        this.cardDetails.card.photo = this.cardsList.find(
          (a) => a._id == this.cardDetails.card._id
        ).photo;
      }

      await this.validateIssuerName(this.cardDetails.selectedIssuer.name);
      await this.validateCardName(this.cardDetails.card.name);
      await this.validateBonus(this.cardDetails.bonus.toString());
      await this.validateBonusType(this.cardDetails.bonusType.value);
      await this.validateLinkUrl(this.cardDetails.linkUrl);
      if (!this.dateNotAvailable) {
        await this.validateExpirationDate(this.cardDetails.date.toString());
      }
      await this.validateEmoji(this.cardDetails.emoji);
      await this.checkinputlink()
      let { issuerName, cardName, bonus, bonusType, url, date, emoji } =
        this.errors;
      if (
        issuerName.success ||
        cardName.success ||
        bonus.success ||
        bonusType.success ||
        url.success ||
        date.success ||
        emoji.success
      ) {
        return false;
      } else {
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(() => {
          this.$axios
            .patch(
              this.$ApiKeys.BASE_URL + this.$EndPoints.Offers 
              + "/" + this.cardDetails._id,
              {
                card: this.cardDetails.card._id,
                bonus_amount: this.cardDetails.bonus,
                bonus_description: this.cardDetails.bonusDescription
                  ? this.cardDetails.bonusDescription
                  : "",
                offer_details: this.cardDetails.offerDetails
                  ? this.cardDetails.offerDetails
                  : "",
                bonus_type: this.cardDetails.bonusType.value,
                expiration_date: this.cardDetails.date,
                emoji: this.cardDetails.emoji.split(".")[0],
                link: this.cardDetails.linkUrl,
                redirect: this.cardDetails.redirect.toString(),
                hide_from_dashboard: this.cardDetails.hide_from_dashboard,
                disclosure: this.cardDetails.disclosure
                  ? this.cardDetails.disclosure
                  : null,
                rates_fees:
                  this.cardDetails.rates_fees &&
                  this.cardDetails.disclosure == "amex"
                    ? this.cardDetails.rates_fees
                    : null,
              }
            )
            .then(async (res) => {
              const errors = res.data.response && res.data.response.errors ? res.data.response.errors : null
              this.$vs.loading.close();
              if (res.data.success) {
                //console.log("success");
                this.$router.push({ name: "offers", params: { edit: true } });
              } else if (
                errors &&
                typeof errors === 'object' &&
                Object.keys(errors)[0]
               ){
                 this.toast(errors[Object.keys(errors)[0]])
              }
               else {
               this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              // this.toast(this.genericErrorMessage());
              if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
              }

              // if (e.response.data.errors && e.response.data.errors.cardId) {
              //   //console.log("error", e);
              //   // this.$refs.wiz.changeTab(3,0);
              //   // this.errors.cardName = {
              //   //     msg: e.response.data.errors.card,
              //   //     success: true
              //   // };
              // } else {
              //   this.errors.cardName = {
              //     msg: "",
              //     sucess: false,
              //   };
              // }
            });
        });
      }
    },
  },
  created() {
    //console.log("created");
    this.getIssuers();
    //this.getCategories();
    EventBus.$emit("resetToggleGroup", true);
  },
  mounted() {
    this.pagename = this.$route.params.pagename;

    if (this.$route.params.data != undefined) {
      this.cardDetails.card = this.$route.params.data.card;
      this.cardDetails.selectedIssuer = this.$route.params.data.card.issuer;
      this.cardDetails.emoji = this.$route.params.data.emoji;
      this.cardDetails._id = this.$route.params.data._id;
      this.cardDetails.bonus = this.$route.params.data.bonus_amount;
      if (this.$route.params.data.expiration_date) {
        this.cardDetails.date = this.$route.params.data.expiration_date;
      } else {
        this.dateNotAvailable = true;
      }
      this.cardDetails.linkUrl = this.$route.params.data.link;
      this.cardDetails.bonusDescription =
        this.$route.params.data.bonus_description;
      this.cardDetails.redirect = this.$route.params.data.redirect;
      this.cardDetails.bonusType.value = this.$route.params.data.bonus_type;
      this.cardDetails.offerDetails = this.$route.params.data.offer_details;
      this.set_issuer_once = 1;
      this.set_card_once = 1;
      this.currentSelectedIssuer = this.cardDetails.selectedIssuer.name;
      if (this.cardDetails.emoji) {
        var a = this.cardDetails.emoji.split(".");
        if (a[1] != "png") {
          this.cardDetails.emoji = this.cardDetails.emoji + ".png";
        }
      }
      this.cardDetails.hide_from_dashboard =
        this.$route.params.data.hide_from_dashboard;

      this.cardDetails.disclosure = this.$route.params.data.disclosure
        ? this.$route.params.data.disclosure
        : "";
      this.cardDetails.rates_fees = this.$route.params.data.rates_fees
        ? this.$route.params.data.rates_fees
        : "";

      this.getCardsList();
    }
  },
  components: {
    UploadCloudIcon,
    PlusSquareIcon,
    MinusSquareIcon,
    Datepicker,
    Editor,
    VueLoadImage,
  },
  mixins: [clickaway],
};
</script>

<style>
@import "../../../../assets/css/tinymce.css";
@import "./style.css";
@import "../../../../assets/css/add-edit-approve-card.css";
</style>

